(function () {
    'use strict';

    angular
        .module('app')
        .factory('config', config);

    config.$inject = ['debug'];

    function config(debug) {

        var service = {
            exists: exists,
            get: get,
        };

        return service;

        function exists(key) {
            return window.config && window.config[key];
        }

        function get(key) {
            if (window.config && typeof window.config[key] !== 'undefined') {
                return window.config[key];
            } else {
                debug.error('Missing config value "' + key + '". Check config.js');
                window.toast({ message: 'Missing config value "' + key + '". Check config.js', type: 'danger' });
                return null;
            }
        }
    }

})();